import './SportsFilter.less';

import React, { FC } from 'react';
import clsx from 'clsx';
import { isMobileChannel } from '../../common/util';
import { SportIconNui } from '../../icons/SportIconNui';

const SportsFilter: FC<{ otherClass?: string; children?: any }> = ({ children, otherClass }) => (
    <nav className={clsx('flex sports-filter', otherClass)}>
        {children}
        <span className="flex-1 bg-white" />
    </nav>
);

export const SportsFilterItem: FC<{
    sportId;
    label;
    otherClass?: string;
    onClick?: () => void;
    active?: boolean;
    children?: any;
}> = ({ sportId, onClick, label, active, otherClass, children }) => {
    const isMobileView = isMobileChannel();
    return (
        <button
            className={clsx(
                'sports-filter-item flex-center',
                otherClass,
                active ? `active filter-item-bgr` : 'bg-black-100 bg-white',
                isMobileView ? 'flex flex-col pt-15 px-10' : 'px-15'
            )}
            onClick={onClick}
        >
            <span className={clsx('fs-0', { 'pr-10': !isMobileView })}>
                <SportIconNui sportId={sportId} className={`flex-shrink-0 fill-${sportId}`} />
            </span>
            <span className={clsx('sports-filter-label no-wrap c-default', isMobileView ? 'fs-10 py-5' : 'fs-14 pt-2')}>
                {label}
            </span>
            {children}
        </button>
    );
};

export default SportsFilter;
